<!-- src/components/P5Wrapper.vue -->
<template>
<div ref="p5Container" class="p5-container" />
</template>

<script>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import p5 from 'p5';

export default {
    name: 'P5Wrapper',

    props: {
        modelValue: {
            type: Object,
            default: null
        },

        sketch: {
            type: Function,
            required: true,
        },
    },

    setup(props, { emit }) {
        const p5Instance = ref(null);
        const p5Container = ref(null);
        let resizeObserver = null;

        const initP5 = (width, height) => {
            // Initialize p5.js with the current container size
            p5Instance.value = new p5((p) => props.sketch(p, width, height), p5Container.value);
            emit('update:modelValue', p5Instance.value);
        };

        onMounted(() => {
            const { clientWidth, clientHeight } = p5Container.value;

            initP5(clientWidth, clientHeight);

            // Set up ResizeObserver to monitor container size changes
            resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    const { width, height } = entry.contentRect;
                    if (p5Instance.value) {
                        p5Instance.value.resizeCanvas(width, height);
                        // Optionally, pass the new size to the sketch if needed
                        if (p5Instance.value.setCanvasSize) {
                            p5Instance.value.setCanvasSize(width, height);
                        }
                    }
                }
            });

            resizeObserver.observe(p5Container.value);
        });

        onBeforeUnmount(() => {
            if (p5Instance.value) {
                p5Instance.value.remove();
            }
        });

        return {
            p5Container,
        };
    },
};
</script>

<style scoped>
.p5-container {
  width: 100%;
  height: 100%;
}
canvas {
  display: block; /* Removes unwanted margins/padding */
}
</style>
